export default {
      id: "sli-play-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.43681d49.svg#sli-play",
      toString: function () {
        return this.url;
      }
    }